import {Template} from "../../../../components/template/template.jsx";
import "../../../../css/style-dashboards.css";
import "../../../../css/style-dash-heat-map.css";
import {useState} from "react";
import DashToggleButton from "../../../../components/button/dash-toggle-button.jsx";
import useSse from "./hooks/use-sse.js";
import GeneralView from "./views/general/general-view.jsx";
import ProtectiveView from "./views/protective/protective-view.jsx";

const API_KEEPER = import.meta.env.VITE_API_KEEPER;
const GENERAL_URL = API_KEEPER + "/sos/dashboard/general/stream";
const PROTECTIVE_URL = API_KEEPER + "/sos/dashboard/protective-measures/stream";

export default function DashboardSos() {
    const [activeView, setActiveView] = useState("general");

    const generalData = useSse(GENERAL_URL, activeView === "general");
    const protectiveData = useSse(PROTECTIVE_URL, activeView === "protective");

    const dashViews = [
        { value: "general", label: "Geral"},
        { value: "protective", label: "Medida protetiva"},
    ];

    return (
        <Template className="dash" isLoading={activeView === "general" && !generalData}>
            <Template.Header className="bg-transparent! border-b-0!">
                <Template.Title className="absolute inset-0 flex items-center justify-center pl-0! text-[#F4FFFF]!">
                    Dashboard SOS
                </Template.Title>
            </Template.Header>
            <Template.Body className="dash-body dashboard-wall-body h-[calc(100vh-69px)] grid grid-cols-12 grid-rows-[50%_50%] relative gap-x-(--dash-gap-md) gap-y-(--dash-gap-md)">
                <div className="absolute left-12 z-20 translate-y-[6px]">
                    <DashToggleButton
                        activeView={activeView}
                        onChange={setActiveView}
                        options={dashViews}
                    />
                </div>

                {activeView === "general" && (
                    <GeneralView general={generalData?.value} />
                )}

                {activeView === "protective" && (
                    <ProtectiveView protective={protectiveData?.value} />
                )}
            </Template.Body>
        </Template>
    )
}
